import React from "react";
import { Container } from "reactstrap";
import Banner from "../../../components/Banner";

const Agreement = () => (
  <React.Fragment>
    <Banner title="이용약관" subtitle="" bg="banner2.jpg" />
    <div className="site-section">
      <Container>
        <div className="row align-items-center justify-content-center text-center">
          <div className="col-md-7">
            <p className="lead mx-auto desc mb-5">
              영국 명문대 출신의 강사들의 협력으로 만들어낸 영국/미국 등 최상의
              해외 명문대 입시 시스템을 가진 플랫폼입니다. 4차 산업시대에 세계로
              향하는 인재를 길러내는 오버더문에듀는 학생이 진정으로 원하는 길이
              무엇인지 함께 고민하고 최선을 다해 같이 걸어가고자 한 사람 한
              사람에게 꼭 맞는 교육프로그램을 연구하고 실천하고 있습니다. 학생이
              원하는 시간에 최고의 선생님을 배치하고, 효율적인 시스템 관리를
              더하여학생에게 꼭 맞는 커리큘럼과 방향, 커뮤니티를 제공합니다.
              아들이 처음 내딛던 발에 환호성을 지르던 순간이 생각이 납니다.
              처음으로 꿈을 펼치는 발걸음을 내딛는 분들과 함께 환호성을 지르며
              응원하는 오버더문에듀가 되겠습니다.
            </p>
          </div>
        </div>
      </Container>
    </div>
  </React.Fragment>
);

export default Agreement;
